var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Box" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.addRegion },
            },
            [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")))]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableRef",
          attrs: {
            data: _vm.tableDate,
            "max-height": 600,
            border: "",
            "header-cell-style": { background: "#f2f2f2" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.ind"),
              align: "center",
              type: "index",
              width: "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.queryForm.pageNumber - 1) *
                            _vm.queryForm.pageSize +
                            scope.$index +
                            1
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.regionNameZh"),
              prop: "zhName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.regionNamePu"),
              prop: "puName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.LatestModifiedBy"),
              prop: "updateUserName",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.LastModified"),
              prop: "updateTime",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.operation"),
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: _vm.$t("GlobalSetObj.edit"),
                          effect: "dark",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              color: "#666",
                              "margin-right": "10px",
                            },
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.edit(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-edit-outline",
                              staticStyle: { "font-size": "20px" },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: _vm.$t("GlobalSetObj.Delete"),
                          effect: "dark",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "el-popconfirm",
                          {
                            attrs: {
                              title: _vm.$t("collectionCenter.deleteSure"),
                            },
                            on: {
                              confirm: function ($event) {
                                return _vm.del(scope.row)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-delete",
                              staticStyle: { "font-size": "20px" },
                              attrs: { slot: "reference" },
                              slot: "reference",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "right" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryForm.pageNumber,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryForm.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.search,
              "size-change": _vm.search1,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("collectionCenter.addRegion"),
            visible: _vm.isAddRegion,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isAddRegion = $event
            },
            close: _vm.closeRegion,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "addRegionRef",
                  attrs: { model: _vm.addRegionForm, "label-position": "top" },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "zhName",
                                label: _vm.$t("collectionCenter.regionNameZh"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("collectionCenter.notNull"),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "100",
                                  "show-word-limit": "",
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.addRegionForm.zhName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addRegionForm, "zhName", $$v)
                                  },
                                  expression: "addRegionForm.zhName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "puName",
                                label: _vm.$t("collectionCenter.regionNamePu"),
                                rules: [
                                  {
                                    required: true,
                                    message: _vm.$t("collectionCenter.notNull"),
                                    trigger: ["blur", "change"],
                                  },
                                ],
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "100",
                                  "show-word-limit": "",
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.addRegionForm.puName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.addRegionForm, "puName", $$v)
                                  },
                                  expression: "addRegionForm.puName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeRegion } }, [
                _vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitRegion } },
                [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.determine")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }